var _path, _g, _g2, _path2, _path3, _g3, _g4, _path4, _path5, _g5, _g6, _path6, _path7, _path8, _g7, _path9, _g8, _path0, _path1, _path10, _path11, _g9, _g0, _path12, _path13, _g1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 32c0 5.9 1.7 11.4 4.6 16h50.7c2.9-4.6 4.6-10.1 4.6-16s-1.7-11.4-4.6-16H6.6C3.7 20.6 2 26.1 2 32z",
    fill: "#ffce31"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ed4c5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4 16C52.1 7.6 42.7 2 32 2S11.9 7.6 6.6 16h50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6 48c5.3 8.4 14.7 14 25.4 14s20.1-5.6 25.4-14H6.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#c8b100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2 28.7h3.2v1.8H9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 41.9h3.3v1.7H9.2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 39.1c-.3.2-.5.4-.5.5c0 .1.1.2.3.3c.2.1.4.3.3.5c.2-.2.3-.4.3-.6c0-.3-.2-.6-.4-.7",
    fill: "#ed4c5c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M9.7 30.5H12v11.4H9.7z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ed4c5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4 34.7c-.5-.2-1.4-.4-2.4-.4c-.3 0-.7 0-1.1.1c-1.4.2-2.5.8-2.4 1.2L8 34.5c-.1-.5 1.1-1.1 2.6-1.4c.5-.1 1-.1 1.4-.1c1 0 1.9.1 2.4.3v1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7 36.2c-.6 0-1.1-.2-1.1-.5c0-.2.2-.5.6-.7h.6l-.1 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 35.3c.4.1.7.2.9.3c.1.1-.3.5-.9.8v-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2 38.4c-.1-.2.6-.6 1.5-.9c.4-.1.7-.3 1.2-.5c1.2-.5 2.2-1.2 2-1.4l.2 1.2c.1.2-.7.8-1.9 1.4c-.4.2-1.1.5-1.5.6c-.7.2-1.3.6-1.3.7l-.2-1.1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#c8b100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7 28.7h3.2v1.8h-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 41.9h3.3v1.7h-3.3z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2 39.1c.3.2.5.4.5.5c0 .1-.1.2-.3.3c-.2.2-.4.5-.3.6c-.2-.2-.3-.4-.3-.6c0-.4.2-.7.4-.8",
    fill: "#ed4c5c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M31.1 30.5h2.3v11.4h-2.3z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ed4c5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7 34.7c.5-.2 1.4-.4 2.4-.4c.3 0 .7 0 1.1.1c1.4.2 2.5.8 2.4 1.2l.5-1.2c.1-.5-1.1-1.1-2.6-1.4h-1.4c-1 0-1.9.1-2.4.3v1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4 36.2c.6 0 1.1-.2 1.1-.5c0-.2-.2-.5-.6-.7h-.6l.1 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1 35.3c-.4.1-.7.2-.9.3c-.1.1.3.5.9.8v-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9 38.4c.1-.2-.6-.6-1.5-.9c-.4-.1-.7-.3-1.2-.5c-1.2-.5-2.2-1.2-2-1.4l-.2 1.2c-.1.2.7.8 1.9 1.4c.4.2 1.1.5 1.5.6c.7.2 1.3.7 1.2.8l.3-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 22.3c1.9 0 5.8.4 7.2 1.8c-1.5 3.6-3.9 2.1-7.2 2.1c-3.2 0-5.7 1.5-7.2-2.1c1.4-1.4 5.2-1.8 7.2-1.8"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#c8b100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4 26.3c-1.2-.7-3-.8-4.9-.8c-1.9 0-3.7.2-4.9.8L17 28c1.1.3 2.7.5 4.5.5c1.8 0 3.3-.2 4.5-.5l.4-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1 22c-.4-.3-1.2-.6-1.9-.6c-.3 0-.6 0-.9.1c0 0-.6-.8-2-.8c-.5 0-.9.1-1.3.3v-.1c-.1-.2-.3-.4-.5-.4s-.5.3-.5.5v.1c-.4-.2-.8-.3-1.3-.3c-1.4 0-2 .9-2 .8c-.3-.1-.6-.1-.9-.1c-4.6 0-2.3 3.1-2.3 3.1l.5-.6c-1.1-1.4-.1-2.2 1.9-2.2c.3 0 .5 0 .7.1c-.7 1 .6 1.9.6 1.9l.3-.5c-.7-.5-.8-2.2 1.2-2.2c.5 0 .9.1 1.3.4c0 .1-.1 1.5-.2 1.7l.8.7l.8-.7c-.1-.3-.2-1.6-.2-1.7c.3-.2.8-.4 1.3-.4c2.1 0 2.1 1.7 1.2 2.2l.3.5s1.1-.9.6-1.9c.2 0 .5-.1.7-.1c2.4 0 2.5 1.8 1.9 2.2l.4.6c-.2 0 .9-1.4-.5-2.6"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 20.1c0-.3.3-.6.6-.6c.4 0 .6.3.6.6s-.3.6-.6.6s-.6-.3-.6-.6",
    fill: "#005bbf"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M21.3 18.4v.3H21v.3h.3v1h-.4v.3h1.2l.1-.2l-.1-.1h-.4v-1h.3v-.3h-.3v-.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 28.3c-1.6 0-3-.2-4.1-.5c1.1-.3 2.5-.5 4.1-.5c1.6 0 3 .2 4.1.5c-1 .3-2.5.5-4.1.5",
    fill: "#ed4c5c"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6 45.6c-1.9 0-3.7-.5-5.3-1.2c-1.2-.6-1.9-1.7-1.9-3v-4.8h14.4v4.8c0 1.3-.8 2.5-1.9 3c-1.6.8-3.4 1.2-5.3 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 28.6h7.2v8h-7.2z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 41.4c0 1.9-1.6 3.4-3.6 3.4s-3.6-1.5-3.6-3.4v-4.8h7.2v4.8",
    fill: "#ed4c5c"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#c8b100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9 44.2c.2.1.5.3.9.4v-8.2H16l-.1 7.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3 41.3c0 1 .4 1.8.8 2.2v-7.1h-.8v4.9"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 44.8h.8v-8.4h-.8v8.4",
    fill: "#c7b500"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 44.6c.3-.1.7-.3.9-.4v-7.8h-.8l-.1 8.2",
    fill: "#c8b100"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed4c5c",
    d: "M14.3 28.6h7.2v8h-7.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 43.5c.4-.3.7-1 .8-1.8v-5.2h-.8v7",
    fill: "#c8b100"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#ed4c5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8 36.6v4.8c0 1.9-1.6 3.4-3.6 3.4s-3.6-1.5-3.6-3.4v-4.8h7.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2 30c.3.6.3 2.1-.6 1.8c.2.1.3.8.6 1.2c.5.6 1.1.1 1-.6c-.2-1.1-.1-1.8.1-2.9c0 .1.5.1.7-.1c-.1.3-.2.7 0 .7c-.2.3-.7.8-.8 1.1c-.1.7 1 2-.2 2.3c-.8.2-.3.8 0 1.1c0 0-.4 1.3-.2 1.2c-.8.3-.6-.4-.6-.4c.4-1.2-.7-1.3-.6-1.5c-1-.1.1.9-.8.9c-.2 0-.6.2-.6.2c-1.1-.1-.5-1.1-.1-1c.3.1.6.6.6-.1c0 0-.5-.8.8-.8c-.5 0-.8-.4-1-.9c-.2.1-.5.6-1.6.7c0 0-.3-1.1 0-.9c.4.2.6.2 1-.2c-.2-.3-1.4-.7-1.2-1.4c0-.2.6-.5.6-.5c-.1.5.2 1 .8 1c.8.1.5-.2.6-.4c.1-.2.7.1.5-.4c0-.1-.7-.2-.5-.5c.4-.5 1-.1 1.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 44.6l-.2-.5l.2-.6l.2.6l-.2.5"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    fill: "#c8b100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 30.3v.5h.2v.4h-.5v1h.3v2.2h-.6v1.1H20v-1.1h-.5v-2.2h.2v-1h-.5v-.4h.3v-.5h-1v.5h.2v.4h-.5V30h.3v-.5h-1.1v.5h.3v1.2h-.5v-.4h.2v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8 42.6v-5h-5.2v5l2.4 1.1h.3l2.5-1.1M25 38v1.7L23.3 38H25m-2.1.1l2 2l-2 2v-4m.2 4.4l1.9-1.9v2.8l-1.9-.9m2.2.8v-2.8l1.9 1.9l-1.9.9m2.1-1.2l-2-2l2-2v4M25.3 38H27l-1.7 1.7V38"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 36.5c0-1.5 1-2.6 2.3-2.6s2.3 1.2 2.3 2.6c0 1.4-1 2.6-2.3 2.6s-2.3-1.1-2.3-2.6",
    fill: "#ed4c5c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9 36.5c0-1.1.7-1.9 1.6-1.9c.9 0 1.6.9 1.6 1.9c0 1.1-.7 1.9-1.6 1.9c-.8.1-1.6-.8-1.6-1.9",
    fill: "#005bbf"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    fill: "#c8b100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8 35.2l-.4 1.1l.3.1l-.2.4h.6l-.2-.4l.3-.1l-.4-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3 35.2l-.4 1.1l.3.1l-.2.4h.6l-.1-.4l.3-.1l-.5-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 36.5l-.5 1.1l.3.1l-.1.4h.5l-.1-.4l.3-.1l-.4-1.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.105b5305073967e45b281c3718d61f1f.svg";
export { ForwardRef as ReactComponent };